/**
 * @file Profile Color Palette
 *
 * Predefined theme colors for professional public profiles.
 * Each color has main, dark, light, and 50 (extra-light) variants
 * for the hero gradient, buttons, table headers, and subtle backgrounds.
 */

export const PROFILE_COLORS = {
  purple: { main: "#5C6BC0", dark: "#3949AB", light: "#C5CAE9", 50: "#E8EAF6", label: "Morado" },
  teal:   { main: "#00897B", dark: "#00695C", light: "#B2DFDB", 50: "#E0F2F1", label: "Verde azulado" },
  blue:   { main: "#1565C0", dark: "#0D47A1", light: "#BBDEFB", 50: "#E3F2FD", label: "Azul" },
  rose:   { main: "#AD1457", dark: "#880E4F", light: "#F8BBD0", 50: "#FCE4EC", label: "Rosa" },
  green:  { main: "#2E7D32", dark: "#1B5E20", light: "#C8E6C9", 50: "#E8F5E9", label: "Verde" },
  orange: { main: "#E65100", dark: "#BF360C", light: "#FFE0B2", 50: "#FFF3E0", label: "Naranja" },
  slate:  { main: "#455A64", dark: "#263238", light: "#CFD8DC", 50: "#ECEFF1", label: "Gris" },
  indigo: { main: "#283593", dark: "#1A237E", light: "#C5CAE9", 50: "#E8EAF6", label: "Índigo" },
  aqua:   { main: "#0097A7", dark: "#00838F", light: "#B2EBF2", 50: "#E0F7FA", label: "Aqua" },
  wine:    { main: "#6D4C41", dark: "#4E342E", light: "#D7CCC8", 50: "#EFEBE9", label: "Vino" },
  gold:    { main: "#D4880F", dark: "#A96800", light: "#FFE0A0", 50: "#FFF8E1", label: "Oro" },
  coral:   { main: "#FF7043", dark: "#E64A19", light: "#FFCCBC", 50: "#FBE9E7", label: "Coral" },
  magenta: { main: "#AB47BC", dark: "#7B1FA2", light: "#CE93D8", 50: "#F3E5F5", label: "Magenta" },
  olive:   { main: "#827717", dark: "#5C6300", light: "#DCE775", 50: "#F9FBE7", label: "Oliva" },
};

export const PROFILE_COLOR_KEYS = Object.keys(PROFILE_COLORS);

export const DEFAULT_PROFILE_COLOR = "purple";
